import { Container } from '@chakra-ui/react';
import { useQuery } from '@tanstack/react-query';
import { FC } from 'react';

import { Section } from '@/components/ui/core/Section/Section';
import { EventListGrid } from '@/components/ui/features/events-list/EventListGrid/EventListGrid';
import { EventListTabs } from '@/components/ui/features/events-list/EventListTabs/EventListTabs';
import { FeaturedEvent } from '@/components/ui/features/events-list/FeaturedEvent/FeaturedEvent';
import { Layout } from '@/components/ui/shared/layouts/Layout/Layout';
import { AccessFrom } from '@/enums/AccessFrom';
import { StringParam, useQueryParams } from '@/hooks/useQueryParams';
import { featuredThinEventQueryOptions } from '@/queries/upgrade/thinEvents';

export const EventListContent: FC = () => {
  const { data: featuredEvents, error: featuredEventsError } = useQuery(featuredThinEventQueryOptions());

  const { accessFrom = AccessFrom.Core } = useQueryParams<{ accessFrom: AccessFrom }>({
    accessFrom: StringParam,
  });

  const featuredEvent = featuredEvents?.[0];

  if (!featuredEvents && !featuredEventsError) {
    return null;
  }

  const pt = featuredEvent ? { base: 28, lg: 20 } : { base: 6, md: 12, lg: 20 };

  return (
    <Layout accessFrom={accessFrom} navigationVariant={featuredEvent ? 'default' : 'inverted'}>
      {featuredEvent && <FeaturedEvent event={featuredEvent} />}
      <Container>
        <Section pt={pt} pb={{ base: 28, lg: 40 }} variant="dimmed" display="block">
          <EventListTabs />
          <EventListGrid />
        </Section>
      </Container>
    </Layout>
  );
};
